import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {field} from "../../../stem-core/state/StoreField.js";

@globalStore
export class AggregateDataGrouping extends BaseStore("AggregateDataGrouping") {
    @field(Array) groupByFields: string[];
    @field(Object) entry: Record<string, any>;
}
